var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-bottom-nav"},[_c('div',{staticClass:"left-actions"},[_vm._t("leftActions")],2),_c('div',{staticClass:"right-actions"},[_vm._t("rightActions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }